import axios from 'axios';
import React, { useState } from 'react';
import { FaBox, FaCalendarAlt, FaCheck, FaCheckCircle, FaCogs, FaDollarSign, FaEnvelope, FaFileAlt, FaGraduationCap, FaHandshake, FaIndustry, FaPen, FaPhoneAlt, FaRegBuilding, FaRegFileAlt, FaRegUser, FaShieldAlt, FaUser } from 'react-icons/fa';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const Form3f9 = () => {

    const [formStep, setFormStep] = useState(1);
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        chiefPromoter: '',
        designation: '',
        yearOfIncorporation: '',
        areasOfOperation: '',
        attendAwards: '',
        willingToSupplement: '',
        willingToPresent: '',
        writeUp: '',
        otherInfo: '',
        legalCompliance: {
            statutoryApprovals: false,
            noPFTaxLiabilities: false,
            noOffences: false,
            notNPA: false,
            noChildEmployment: false,
        },
        applicantName: '',
        applicantDesignation: '',
        applicantEmail: '',
        applicantPhone: '',
        signature: '',
    });

    const [signatureFile, setSignatureFile] = useState(null);

    const handleSignatureChange = (e) => {
        setSignatureFile(e.target.files[0]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData({
            ...formData,
            legalCompliance: {
                ...formData.legalCompliance,
                [name]: checked ? 1 : 0,
            },
        });
    };

    const [form1_id, setForm1Id] = useState('');
    const [email, setForm1Email] = useState('');

    const handleSubmit1 = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('phone', formData.phone);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('chiefPromoter', formData.chiefPromoter);
        formDataToSend.append('designation', formData.designation);
        formDataToSend.append('yearOfIncorporation', formData.yearOfIncorporation);
        formDataToSend.append('areasOfOperation', formData.areasOfOperation);
        formDataToSend.append('attendAwards', formData.attendAwards);
        formDataToSend.append('willingToSupplement', formData.willingToSupplement);
        formDataToSend.append('willingToPresent', formData.willingToPresent);
        formDataToSend.append('writeUp', formData.writeUp);
        formDataToSend.append('otherInfo', formData.otherInfo);

        formDataToSend.append('statutoryApprovals', formData.legalCompliance.statutoryApprovals ? '1' : '0');
        formDataToSend.append('noPFTaxLiabilities', formData.legalCompliance.noPFTaxLiabilities ? '1' : '0');
        formDataToSend.append('noOffences', formData.legalCompliance.noOffences ? '1' : '0');
        formDataToSend.append('notNPA', formData.legalCompliance.notNPA ? '1' : '0');
        formDataToSend.append('noChildEmployment', formData.legalCompliance.noChildEmployment ? '1' : '0');

        formDataToSend.append('applicantName', formData.applicantName);
        formDataToSend.append('applicantDesignation', formData.applicantDesignation);
        formDataToSend.append('applicantEmail', formData.applicantEmail);
        formDataToSend.append('applicantPhone', formData.applicantPhone);

        if (signatureFile) {
            formDataToSend.append('signature', signatureFile);
        }

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api-form1/submit', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            setForm1Id(response.data.form1_id);
            setForm1Email(response.data.email);
            setFormStep(2);
            alert('Form submitted successfully');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
        }
    };


    //  ---------> form 2

    const [snapshotOfOrganisation, setSnapshotOfOrganisation] = useState('');
    const [vision, setVision] = useState('');
    const [achievementsOfOrganisation, setAchievementsOfOrganisation] = useState('');
    const [contributionToExchequer, setContributionToExchequer] = useState('');
    const [sizeOfOrganisationBelow10, setSizeOfOrganisationBelow10] = useState('');
    const [sizeOfOrganisation10to20, setSizeOfOrganisation10to20] = useState('');
    const [sizeOfOrganisation20to50, setSizeOfOrganisation20to50] = useState('');
    const [sizeOfOrganisationAbove50, setSizeOfOrganisationAbove50] = useState('');
    const [ownershipSoleProprietor, setOwnershipSoleProprietor] = useState(false);
    const [ownershipPartnershipFirm, setOwnershipPartnershipFirm] = useState(false);
    const [ownershipPrivateLimitedCompany, setOwnershipPrivateLimitedCompany] = useState(false);
    const [ownershipLimitedCompany, setOwnershipLimitedCompany] = useState(false);
    const [ownershipCooperativeSociety, setOwnershipCooperativeSociety] = useState(false);
    const [sectorPrivate, setSectorPrivate] = useState(false);
    const [sectorPublic, setSectorPublic] = useState(false);
    const [sectorGovernmentCentral, setSectorGovernmentCentral] = useState(false);
    const [sectorGovernmentState, setSectorGovernmentState] = useState(false);
    const [sectorOthers, setSectorOthers] = useState(false);
    const [noOfEmployeesLessThan20, setNoOfEmployeesLessThan20] = useState('');
    const [noOfEmployees20to50, setNoOfEmployees20to50] = useState('');
    const [noOfEmployees50to100, setNoOfEmployees50to100] = useState('');
    const [noOfEmployeesAbove100, setNoOfEmployeesAbove100] = useState('');
    const [financialResults2021_22, setFinancialResults2021_22] = useState('');
    const [financialResults2022_23, setFinancialResults2022_23] = useState('');
    const [financialResults2023_24, setFinancialResults2023_24] = useState('');

    const [main_products_services_description1, setMainProductsServicesDescription1] = useState('');
    const [main_products_services_capacity1, setMainProductsServicesCapacity1] = useState('');
    const [main_products_services_description2, setMainProductsServicesDescription2] = useState('');
    const [main_products_services_capacity2, setMainProductsServicesCapacity2] = useState('');
    const [main_products_services_description3, setMainProductsServicesDescription3] = useState('');
    const [main_products_services_capacity3, setMainProductsServicesCapacity3] = useState('');
    const [major_facilities_land_area, setMajorFacilitiesLandArea] = useState('');
    const [major_facilities_factory_built_up_area, setMajorFacilitiesFactoryBuiltUpArea] = useState('');
    const [major_facilities_major_equipment, setMajorFacilitiesMajorEquipment] = useState('');
    const [major_facilities_specialized_facility, setMajorFacilitiesSpecializedFacility] = useState('');
    const [major_facilities_services, setMajorFacilitiesServices] = useState('');
    const [technology_adopted_traditional, setTechnologyAdoptedTraditional] = useState(false);
    const [technology_adopted_indigenous, setTechnologyAdoptedIndigenous] = useState(false);
    const [technology_adopted_in_house_r_d, setTechnologyAdoptedInHouseRD] = useState(false);
    const [technology_adopted_foreign_technology, setTechnologyAdoptedForeignTechnology] = useState(false);
    const [technology_adopted_franchise, setTechnologyAdoptedFranchise] = useState(false);
    const [technology_adopted_comment, setTechnologyAdoptedComment] = useState('');
    const [quality_compliance_iso, setQualityComplianceIso] = useState(false);
    const [quality_compliance_bis, setQualityComplianceBis] = useState(false);
    const [quality_compliance_gmp_who_fda_haccp, setQualityComplianceGmpWhoFdaHaccp] = useState(false);
    const [quality_compliance_other, setQualityComplianceOther] = useState(false);
    const [quality_compliance_comment, setQualityComplianceComment] = useState('');
    const [management_functions_human_resources_department, setManagementFunctionsHumanResourcesDepartment] = useState(false);
    const [management_functions_finance_accounts, setManagementFunctionsFinanceAccounts] = useState(false);
    const [management_functions_marketing_business_development, setManagementFunctionsMarketingBusinessDevelopment] = useState(false);
    const [management_functions_r_d, setManagementFunctionsRD] = useState(false);
    const [management_functions_internal_audit, setManagementFunctionsInternalAudit] = useState(false);
    const [management_functions_quality_assurance, setManagementFunctionsQualityAssurance] = useState(false);
    const [management_functions_other, setManagementFunctionsOther] = useState(false);
    const [management_functions_comment, setManagementFunctionsComment] = useState('');
    const [level_of_it_intervention_use_of_erp, setLevelOfITInterventionUseOfERP] = useState(false);
    const [level_of_it_intervention_customized_software, setLevelOfITInterventionCustomizedSoftware] = useState(false);
    const [level_of_it_intervention_general_office_solutions, setLevelOfITInterventionGeneralOfficeSolutions] = useState(false);
    const [level_of_it_intervention_no_it_facility, setLevelOfITInterventionNoITFacility] = useState(false);
    const [level_of_it_intervention_comment, setLevelOfITInterventionComment] = useState('');
    const [award_recognition_yes, setAwardRecognitionYes] = useState(false);
    const [award_recognition_no, setAwardRecognitionNo] = useState(false);
    const [award_recognition_comment, setAwardRecognitionComment] = useState('');

    const [strategic_plan_for_future_yes, setStrategicPlanForFutureYes] = useState(false);
    const [strategic_plan_for_future_no, setStrategicPlanForFutureNo] = useState(false);
    const [strategic_plan_for_future_comment, setStrategicPlanForFutureComment] = useState('');

    const [about_product_service_description, setAboutProductServiceDescription] = useState('');
    const [about_product_service_capacity, setAboutProductServiceCapacity] = useState('');
    const [about_product_service_features, setAboutProductServiceFeatures] = useState('');
    const [about_product_service_uniqueness, setAboutProductServiceUniqueness] = useState('');
    const [about_product_service_market, setAboutProductServiceMarket] = useState('');
    const [about_product_service_export_content_in_turnover, setAboutProductServiceExportContentInTurnover] = useState('');

    const [about_chief_promoter_educational_qualification, setAboutChiefPromoterEducationalQualification] = useState('');
    const [about_chief_promoter_experience_in_line, setAboutChiefPromoterExperienceInLine] = useState('');
    const [about_chief_promoter_first_generation_entrepreneur, setAboutChiefPromoterFirstGenerationEntrepreneur] = useState('');
    const [about_chief_promoter_contribution_to_organisation, setAboutChiefPromoterContributionToOrganisation] = useState('');
    const [about_chief_promoter_relevant_details, setAboutChiefPromoterRelevantDetails] = useState('');

    const [signatureUrl, setSignatureUrl] = useState('');
    const [name, setName] = useState('');
    const [designation, setDesignation] = useState('');

    // Handle form submission
    const handleSubmit2 = async (e) => {
        e.preventDefault();

        const formData = {
            snapshot_of_organisation: snapshotOfOrganisation,
            vision: vision,
            achievements_of_organisation: achievementsOfOrganisation,
            contribution_to_exchequer: contributionToExchequer,
            size_of_organisation_below_10: sizeOfOrganisationBelow10,
            size_of_organisation_10_20: sizeOfOrganisation10to20,
            size_of_organisation_20_50: sizeOfOrganisation20to50,
            size_of_organisation_above_50: sizeOfOrganisationAbove50,
            ownership_sole_proprietor: ownershipSoleProprietor,
            ownership_partnership_firm: ownershipPartnershipFirm,
            ownership_private_limited_company: ownershipPrivateLimitedCompany,
            ownership_limited_company: ownershipLimitedCompany,
            ownership_cooperative_society: ownershipCooperativeSociety,
            sector_private: sectorPrivate,
            sector_public: sectorPublic,
            sector_government_central: sectorGovernmentCentral,
            sector_government_state: sectorGovernmentState,
            sector_others: sectorOthers,
            no_of_employees_less_than_20: noOfEmployeesLessThan20,
            no_of_employees_20_50: noOfEmployees20to50,
            no_of_employees_50_100: noOfEmployees50to100,
            no_of_employees_above_100: noOfEmployeesAbove100,
            financial_results_2021_22: financialResults2021_22,
            financial_results_2022_23: financialResults2022_23,
            financial_results_2023_24: financialResults2023_24,

            main_products_services_description1,
            main_products_services_capacity1,
            main_products_services_description2,
            main_products_services_capacity2,
            main_products_services_description3,
            main_products_services_capacity3,
            major_facilities_land_area,
            major_facilities_factory_built_up_area,
            major_facilities_major_equipment,
            major_facilities_specialized_facility,
            major_facilities_services,
            technology_adopted_traditional,
            technology_adopted_indigenous,
            technology_adopted_in_house_r_d,
            technology_adopted_foreign_technology,
            technology_adopted_franchise,
            technology_adopted_comment,
            quality_compliance_iso,
            quality_compliance_bis,
            quality_compliance_gmp_who_fda_haccp,
            quality_compliance_other,
            quality_compliance_comment,
            management_functions_human_resources_department,
            management_functions_finance_accounts,
            management_functions_r_d,
            management_functions_internal_audit,
            management_functions_quality_assurance,
            management_functions_other,
            management_functions_marketing_business_development,
            management_functions_comment,
            level_of_it_intervention_use_of_erp,
            level_of_it_intervention_customized_software,
            level_of_it_intervention_general_office_solutions,
            level_of_it_intervention_no_it_facility,
            level_of_it_intervention_comment,
            award_recognition_yes,
            award_recognition_no,
            award_recognition_comment,
            strategic_plan_for_future_yes,
            strategic_plan_for_future_no,
            strategic_plan_for_future_comment,
            about_product_service_description,
            about_product_service_capacity,
            about_product_service_features,
            about_product_service_uniqueness,
            about_product_service_market,
            about_product_service_export_content_in_turnover,
            about_chief_promoter_educational_qualification,
            about_chief_promoter_experience_in_line,
            about_chief_promoter_first_generation_entrepreneur,
            about_chief_promoter_contribution_to_organisation,
            about_chief_promoter_relevant_details,

            signature_url: signatureUrl,
            name,
            designation,
            form1_id: form1_id,
        };

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/submit-nomination', formData);
            alert('Data submitted successfully');
            setFormStep(3);
            console.log('respose Data', response);
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert('Error submitting form');
        }
    };

    /// form 3----------------->

    const [Name7, setName7] = useState('');
    const [Designation7, setDesignation7] = useState('');
    const [Age, setAge] = useState('');
    const [Technical_PG, setTechnicalPG] = useState('');
    const [Technical_Graduate, setTechnicalGraduate] = useState('');
    const [Technical_Other, setTechnicalOther] = useState('');
    const [Financial_PG, setFinancialPG] = useState('');
    const [Financial_Graduate, setFinancialGraduate] = useState('');
    const [Financial_Other, setFinancialOther] = useState('');
    const [Management_PG, setManagementPG] = useState('');
    const [Management_Graduate, setManagementGraduate] = useState('');
    const [Management_Other, setManagementOther] = useState('');
    const [Professional_PG, setProfessionalPG] = useState('');
    const [Professional_Graduate, setProfessionalGraduate] = useState('');
    const [Professional_Other, setProfessionalOther] = useState('');
    const [Other_PG, setOtherPG] = useState('');
    const [Other_Graduate, setOtherGraduate] = useState('');
    const [Other_Other, setOtherOther] = useState('');

    const [Experience_Total, setExperienceTotal] = useState('');
    const [Experience_In_Same_Line, setExperienceInSameLine] = useState('');
    const [Experience_In_Same_Organization, setExperienceInSameOrganization] = useState('');

    const [Nominee_Chief_Promotor, setNomineeChiefPromotor] = useState('');
    const [Nominee_First_Generation, setNomineeFirstGeneration] = useState('');

    const [Business, setBusiness] = useState('');
    const [Industry, setIndustry] = useState('');
    const [Agriculture, setAgriculture] = useState('');
    const [Service, setService] = useState('');
    const [Other_Tech, setOtherTech] = useState('');
    const [Family_Background_comment, setFamilyBackgroundComment] = useState('');

    const [Traditional, setTraditional] = useState('');
    const [Existing, setExisting] = useState('');
    const [Innovative, setInnovative] = useState('');
    const [Import_Substitute, setImportSubstitute] = useState('');
    const [Product_Service_comment, setProductServiceComment] = useState('');

    const [Indigenous, setIndigenous] = useState('');
    const [Own_RD, setOwnRD] = useState('');
    const [Imported, setImported] = useState('');
    const [Source_of_Technology_Comment, setSourceOfTechnologyComment] = useState('');

    const [Investment_in_Rs_Cr_At_Start, setInvestmentAtStart] = useState('');
    const [Investment_in_Rs_Cr_At_End, setInvestmentAtEnd] = useState('');
    const [Term_Loan_in_Rs_Cr_At_Start, setTermLoanAtStart] = useState('');
    const [Term_Loan_in_Rs_Cr_At_End, setTermLoanAtEnd] = useState('');
    const [Turnover_in_Rs_Cr_At_Start, setTurnoverAtStart] = useState('');
    const [Turnover_in_Rs_Cr_At_End, setTurnoverAtEnd] = useState('');
    const [PBT_in_Rs_Cr_At_Start, setPBTAtStart] = useState('');
    const [PBT_in_Rs_Cr_At_End, setPBTAtEnd] = useState('');
    const [Manpower_Skilled_Unskilled_At_Start, setManpowerAtStart] = useState('');
    const [Manpower_Skilled_Unskilled_At_End, setManpowerAtEnd] = useState('');
    const [Exports_in_Rs_Cr_At_Start, setExportsAtStart] = useState('');
    const [Exports_in_Rs_Cr_At_End, setExportsAtEnd] = useState('');

    const [Turnover_At_Start, setTurnoverAtStartYear] = useState('');
    const [Turnover_Year1, setTurnoverYear1] = useState('');
    const [Turnover_Year2, setTurnoverYear2] = useState('');
    const [Turnover_Year3, setTurnoverYear3] = useState('');
    const [PAT_At_Start, setPATAtStart] = useState('');
    const [PAT_Year1, setPATYear1] = useState('');
    const [PAT_Year2, setPATYear2] = useState('');
    const [PAT_Year3, setPATYear3] = useState('');
    const [DER_At_Start, setDERAtStart] = useState('');
    const [DER_Year1, setDERYear1] = useState('');
    const [DER_Year2, setDERYear2] = useState('');
    const [DER_Year3, setDERYear3] = useState('');
    const [Net_Profit_Sales_At_Start, setNetProfitSalesAtStart] = useState('');
    const [Net_Profit_Sales_Year1, setNetProfitSalesYear1] = useState('');
    const [Net_Profit_Sales_Year2, setNetProfitSalesYear2] = useState('');
    const [Net_Profit_Sales_Year3, setNetProfitSalesYear3] = useState('');
    const [Current_Ratio_At_Start, setCurrentRatioAtStart] = useState('');
    const [Current_Ratio_Year1, setCurrentRatioYear1] = useState('');
    const [Current_Ratio_Year2, setCurrentRatioYear2] = useState('');
    const [Current_Ratio_Year3, setCurrentRatioYear3] = useState('');
    const [Net_Worth_At_Start, setNetWorthAtStart] = useState('');
    const [Net_Worth_Year1, setNetWorthYear1] = useState('');
    const [Net_Worth_Year2, setNetWorthYear2] = useState('');
    const [Net_Worth_Year3, setNetWorthYear3] = useState('');
    const [ROI_At_Start, setROIAtStart] = useState('');
    const [ROI_Year1, setROIYear1] = useState('');
    const [ROI_Year2, setROIYear2] = useState('');
    const [ROI_Year3, setROIYear3] = useState('');
    const [Revenue_per_Employee_At_Start, setRevenuePerEmployeeAtStart] = useState('');
    const [Revenue_per_Employee_Year1, setRevenuePerEmployeeYear1] = useState('');
    const [Revenue_per_Employee_Year2, setRevenuePerEmployeeYear2] = useState('');
    const [Revenue_per_Employee_Year3, setRevenuePerEmployeeYear3] = useState('');

    const [ISO, setISO] = useState('');
    const [HACCP, setHACCP] = useState('');
    const [WHO_GMP_FDA, setWHO_GMP_FDA] = useState('');
    const [Any_Other, setAnyOther] = useState('');
    const [Orientation_for_Quality_comment, setOrientationForQualityComment] = useState('');

    const [Large_Companies, setLargeCompanies] = useState('');
    const [Small_Units, setSmallUnits] = useState('');
    const [Public_At_Large, setPublicAtLarge] = useState('');
    const [Export_As_OEM, setExportAsOEM] = useState('');
    const [As_OEM, setAsOEM] = useState('');
    const [Product_Caters_comment, setProductCatersComment] = useState('');

    const [Large_Companies_Comment, setLargeCompaniesComment] = useState('');
    const [Small_Units_Comment, setSmallUnitsComment] = useState('');
    const [Multi_Nationals, setMultiNationals] = useState('');
    const [Imports, setImports] = useState('');
    const [Competitors_comment, setCompetitorsComment] = useState('');

    const [Increase_in_turnover, setIncreaseInTurnover] = useState('');
    const [Increase_in_productivity, setIncreaseInProductivity] = useState('');
    const [Increase_in_quality, setIncreaseInQuality] = useState('');
    const [Increase_in_areas_of_operation, setIncreaseInAreasOfOperation] = useState('');
    const [Introduction_of_new_practices, setIntroductionOfNewPractices] = useState('');
    const [Innovations_done, setInnovationsDone] = useState('');
    const [Implemented_Good_HR_practices, setImplementedGoodHRPractices] = useState('');
    const [Any_turnaround_activity, setAnyTurnaroundActivity] = useState('');
    const [Devising_strategic_plan, setDevisingStrategicPlan] = useState('');
    const [Use_of_innovative_IT, setUseOfInnovativeIT] = useState('');
    const [Development_of_RD_and_technology, setDevelopmentOfRDandTechnology] = useState('');
    const [Energy_conservation_green_energy, setEnergyConservationGreenEnergy] = useState('');
    const [CSR_activities, setCSRActivities] = useState('');
    const [Received_Recognition_awards, setReceivedRecognitionAwards] = useState('');
    const [Promoted_other_units, setPromotedOtherUnits] = useState('');
    const [Competing_with_large_Enterprises, setCompetingWithLargeEnterprises] = useState('');
    const [Nominee_for_Organization_comment, setNomineeForOrganizationComment] = useState('');
    const [Contribution_performance_comment, setContributionPerformanceComment] = useState('');
    const [Eligible_for_this_award_comment, setEligibleForThisAwardComment] = useState('');
    const [Date, setDate] = useState('');

    const [Signature_of_CEO_MD, setSignatureOfCEOMD] = useState('');

    const [Name1, setName1] = useState('');

    const handleRadioChange = (setter) => (event) => {
        setter(event.target.checked);
    };

    const handleFileChange = (e) => {
        setSignatureOfCEOMD(e.target.files[0]);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        const data = new FormData();

        data.append('Name', Name7);
        data.append('Designation', Designation7);
        data.append('Age', Age);
        data.append('Technical_PG', Technical_PG);
        data.append('Technical_Graduate', Technical_Graduate);
        data.append('Technical_Other', Technical_Other);
        data.append('Financial_PG', Financial_PG);
        data.append('Financial_Graduate', Financial_Graduate);
        data.append('Financial_Other', Financial_Other);
        data.append('Management_PG', Management_PG);
        data.append('Management_Graduate', Management_Graduate);
        data.append('Management_Other', Management_Other);
        data.append('Professional_PG', Professional_PG);
        data.append('Professional_Graduate', Professional_Graduate);
        data.append('Professional_Other', Professional_Other);
        data.append('Other_PG', Other_PG);
        data.append('Other_Graduate', Other_Graduate);
        data.append('Other_Other', Other_Other);
        data.append('Experience_Total', Experience_Total);
        data.append('Experience_In_Same_Line', Experience_In_Same_Line);
        data.append('Experience_In_Same_Organization', Experience_In_Same_Organization);
        data.append('Nominee_Chief_Promotor', Nominee_Chief_Promotor);
        data.append('Nominee_First_Generation', Nominee_First_Generation);
        data.append('Business', Business);
        data.append('Industry', Industry);
        data.append('Agriculture', Agriculture);
        data.append('Service', Service);
        data.append('Other_Tech', Other_Tech);
        data.append('Family_Background_comment', Family_Background_comment);
        data.append('Traditional', Traditional);
        data.append('Existing', Existing);
        data.append('Innovative', Innovative);
        data.append('Import_Substitute', Import_Substitute);
        data.append('Product_Service_comment', Product_Service_comment);
        data.append('Indigenous', Indigenous);
        data.append('Own_RD', Own_RD);
        data.append('Imported', Imported);
        data.append('Source_of_Technology_Comment', Source_of_Technology_Comment);
        data.append('Investment_in_Rs_Cr_At_Start', Investment_in_Rs_Cr_At_Start);
        data.append('Investment_in_Rs_Cr_At_End', Investment_in_Rs_Cr_At_End);
        data.append('Term_Loan_in_Rs_Cr_At_Start', Term_Loan_in_Rs_Cr_At_Start);
        data.append('Term_Loan_in_Rs_Cr_At_End', Term_Loan_in_Rs_Cr_At_End);
        data.append('Turnover_in_Rs_Cr_At_Start', Turnover_in_Rs_Cr_At_Start);
        data.append('Turnover_in_Rs_Cr_At_End', Turnover_in_Rs_Cr_At_End);
        data.append('PBT_in_Rs_Cr_At_Start', PBT_in_Rs_Cr_At_Start);
        data.append('PBT_in_Rs_Cr_At_End', PBT_in_Rs_Cr_At_End);
        data.append('Manpower_Skilled_Unskilled_At_Start', Manpower_Skilled_Unskilled_At_Start);
        data.append('Manpower_Skilled_Unskilled_At_End', Manpower_Skilled_Unskilled_At_End);
        data.append('Exports_in_Rs_Cr_At_Start', Exports_in_Rs_Cr_At_Start);
        data.append('Exports_in_Rs_Cr_At_End', Exports_in_Rs_Cr_At_End);
        data.append('Turnover_At_Start', Turnover_At_Start);
        data.append('Turnover_Year1', Turnover_Year1);
        data.append('Turnover_Year2', Turnover_Year2);
        data.append('Turnover_Year3', Turnover_Year3);
        data.append('PAT_At_Start', PAT_At_Start);
        data.append('PAT_Year1', PAT_Year1);
        data.append('PAT_Year2', PAT_Year2);
        data.append('PAT_Year3', PAT_Year3);
        data.append('DER_At_Start', DER_At_Start);
        data.append('DER_Year1', DER_Year1);
        data.append('DER_Year2', DER_Year2);
        data.append('DER_Year3', DER_Year3);
        data.append('Net_Profit_Sales_At_Start', Net_Profit_Sales_At_Start);
        data.append('Net_Profit_Sales_Year1', Net_Profit_Sales_Year1);
        data.append('Net_Profit_Sales_Year2', Net_Profit_Sales_Year2);
        data.append('Net_Profit_Sales_Year3', Net_Profit_Sales_Year3);
        data.append('Current_Ratio_At_Start', Current_Ratio_At_Start);
        data.append('Current_Ratio_Year1', Current_Ratio_Year1);
        data.append('Current_Ratio_Year2', Current_Ratio_Year2);
        data.append('Current_Ratio_Year3', Current_Ratio_Year3);
        data.append('Net_Worth_At_Start', Net_Worth_At_Start);
        data.append('Net_Worth_Year1', Net_Worth_Year1);
        data.append('Net_Worth_Year2', Net_Worth_Year2);
        data.append('Net_Worth_Year3', Net_Worth_Year3);
        data.append('ROI_At_Start', ROI_At_Start);
        data.append('ROI_Year1', ROI_Year1);
        data.append('ROI_Year2', ROI_Year2);
        data.append('ROI_Year3', ROI_Year3);
        data.append('Revenue_per_Employee_At_Start', Revenue_per_Employee_At_Start);
        data.append('Revenue_per_Employee_Year1', Revenue_per_Employee_Year1);
        data.append('Revenue_per_Employee_Year2', Revenue_per_Employee_Year2);
        data.append('Revenue_per_Employee_Year3', Revenue_per_Employee_Year3);
        data.append('ISO', ISO);
        data.append('HACCP', HACCP);
        data.append('WHO_GMP_FDA', WHO_GMP_FDA);
        data.append('Any_Other', Any_Other);
        data.append('Orientation_for_Quality_comment', Orientation_for_Quality_comment);
        data.append('Large_Companies', Large_Companies);
        data.append('Small_Units', Small_Units);
        data.append('Public_At_Large', Public_At_Large);
        data.append('Export_As_OEM', Export_As_OEM);
        data.append('As_OEM', As_OEM);
        data.append('Product_Caters_comment', Product_Caters_comment);
        data.append('Large_Companies_Comment', Large_Companies_Comment);
        data.append('Small_Units_Comment', Small_Units_Comment);
        data.append('Multi_Nationals', Multi_Nationals);
        data.append('Imports', Imports);
        data.append('Competitors_comment', Competitors_comment);
        data.append('Increase_in_turnover', Increase_in_turnover);
        data.append('Increase_in_productivity', Increase_in_productivity);
        data.append('Increase_in_quality', Increase_in_quality);
        data.append('Increase_in_areas_of_operation', Increase_in_areas_of_operation);
        data.append('Introduction_of_new_practices', Introduction_of_new_practices);
        data.append('Innovations_done', Innovations_done);
        data.append('Implemented_Good_HR_practices', Implemented_Good_HR_practices);
        data.append('Any_turnaround_activity', Any_turnaround_activity);
        data.append('Devising_strategic_plan', Devising_strategic_plan);
        data.append('Use_of_innovative_IT', Use_of_innovative_IT);
        data.append('Development_of_RD_and_technology', Development_of_RD_and_technology);
        data.append('Energy_conservation_green_energy', Energy_conservation_green_energy);
        data.append('CSR_activities', CSR_activities);
        data.append('Received_Recognition_awards', Received_Recognition_awards);
        data.append('Promoted_other_units', Promoted_other_units);
        data.append('Competing_with_large_Enterprises', Competing_with_large_Enterprises);
        data.append('Nominee_for_Organization_comment', Nominee_for_Organization_comment);
        data.append('Contribution_performance_comment', Contribution_performance_comment);
        data.append('Eligible_for_this_award_comment', Eligible_for_this_award_comment);
        data.append('Date', Date);

        data.append('Signature_of_CEO_MD', Signature_of_CEO_MD);

        data.append('Name1', Name1);
        data.append('form1_id', form1_id);
        data.append('email', email);


        axios.post('https://rvapi.emedha.in/pages/api/small_scale_award', data)
            .then(response => {
                alert('Data submitted successfully!');
                console.log(response);
                window.location.reload();
            })
            .catch(error => {
                console.error('There was an error submitting the form!', error);
            });
    };


    return (
        <>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '230px', width: '100%' }} />

            <div className='mt-4' style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {[1, 2, 3].map((stepNumber) => (
                    <div
                        key={stepNumber} style={{ width: '60px', height: '30px', borderRadius: '10%', backgroundColor: formStep === stepNumber ? '#007bff' : '#ccc', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', cursor: formStep >= stepNumber ? 'pointer' : 'not-allowed', margin: '0 5px', opacity: formStep >= stepNumber ? 1 : 0.5, }}
                        onClick={() => { if (formStep >= stepNumber) { setFormStep(stepNumber); } }}>
                        {stepNumber}
                    </div>
                ))}
            </div>

            {formStep === 1 && (
                <div className='container'>
                    <h3 style={{ textAlign: 'center', marginBottom: '20px', textTransform: 'uppercase' }}>Declaration Form for Nominations</h3>
                    <form >
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name:</label>
                                <input type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegBuilding /> Address:</label>
                                <input type="text" name="address" placeholder="Enter Address" value={formData.address} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone:</label>
                                <input type="text" name="phone" placeholder="Enter Phone" value={formData.phone} maxLength={10} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email:</label>
                                <input type="email" name="email" placeholder="Enter Email" value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPen /> Chief Promoter Name:</label>
                                <input type="text" name="chiefPromoter" placeholder="Enter Chief Promoter Name" value={formData.chiefPromoter} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation:</label>
                                <input type="text" name="designation" placeholder="Enter Designation" value={formData.designation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Year of Incorporation:</label>
                                <input type="text" name="yearOfIncorporation" value={formData.yearOfIncorporation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Areas of Operation:</label>
                                <input type="text" name="areasOfOperation" value={formData.areasOfOperation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> If selected, will you attend to the awards function to accept the award:</label>
                                <select name="attendAwards" value={formData.attendAwards} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to supplement any further information?</label>
                                <select name="willingToSupplement" value={formData.willingToSupplement} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to make a presentation before the jury?</label>
                                <select name="willingToPresent" value={formData.willingToPresent} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Write a brief 200-word write-up on why you consider yourself suitable for this Award:</label>
                            <textarea name="writeUp" value={formData.writeUp} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" required />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Any other relevant information in support of the proposal:</label>
                            <textarea name="otherInfo" value={formData.otherInfo} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaShieldAlt /> Legal & Statutory compliance:</label>
                            <div style={{ border: '2px solid #000', padding: '15px', borderRadius: '5px', backgroundColor: '#f8f9fa' }}>
                                <label>
                                    <input type="checkbox" name="statutoryApprovals" checked={formData.legalCompliance.statutoryApprovals} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Has all Statutory approvals
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noPFTaxLiabilities" checked={formData.legalCompliance.noPFTaxLiabilities} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No PF/Tax liabilities
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noOffences" checked={formData.legalCompliance.noOffences} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not involved in any Civil/Criminal/Economic offences
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="notNPA" checked={formData.legalCompliance.notNPA} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not an NPA with Banks/FI
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noChildEmployment" checked={formData.legalCompliance.noChildEmployment} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No Child employment
                                </label>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name of Applicant:</label>
                                <input type="text" name="applicantName" value={formData.applicantName} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation (CEO/MD/Chief Promoter):</label>
                                <input type="text" name="applicantDesignation" value={formData.applicantDesignation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email ID:</label>
                                <input type="email" name="applicantEmail" value={formData.applicantEmail} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone/Mobile:</label>
                                <input type="text" name="applicantPhone" value={formData.applicantPhone} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Signature of Applicant and Company seal:</label>
                            <input type="file" name="signature" accept="image/*" onChange={handleSignatureChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit1} className="btn btn-primary w-100">Submit</button>
                        </div>
                    </form>
                </div>
            )}

            {formStep === 2 && (
                <div className="container">
                    <form>
                        <h4 className='mt-2 mb-2 text-center'>FORM - 2</h4>
                        <p className='mb-0'>A. About the Organisation: (Write up in brief)</p>
                        <div className="mb-3">
                            <label htmlFor="organizationSnapshot" className="form-label">i. A snapshot of the Organisation, chief promoter, the key activities, challenges faced, competition, exports etc.</label>
                            <textarea value={snapshotOfOrganisation} onChange={(e) => setSnapshotOfOrganisation(e.target.value)} className="form-control" id="organizationSnapshot" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section ii */}
                        <div className="mb-3">
                            <label htmlFor="visionMission" className="form-label">ii. Vision, mission and policy of organization</label>
                            <textarea value={vision} onChange={(e) => setVision(e.target.value)} className="form-control" id="visionMission" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iii */}
                        <div className="mb-3">
                            <label htmlFor="achievements" className="form-label">iii. Important achievements of Organisation in the past few years</label>
                            <textarea value={achievementsOfOrganisation} onChange={(e) => setAchievementsOfOrganisation(e.target.value)} className="form-control" id="achievements" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iv */}
                        <div className="mb-3">
                            <label htmlFor="contribution" className="form-label">iv. Contribution to exchequer, society, CSR etc.</label>
                            <textarea value={contributionToExchequer} onChange={(e) => setContributionToExchequer(e.target.value)} className="form-control" id="contribution" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Size of Organisation */}
                        <h5>1. Size of Organisation: (investment in plant & machinery) in Rs Cr</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Below 10</td>
                                    <td><input type="radio" id="below10" name="size" value="below10" onChange={() => setSizeOfOrganisationBelow10('Below 10')} /></td>
                                </tr>
                                <tr>
                                    <td>B. 10 - 20</td>
                                    <td> <input type="radio" id="10to20" name="size" value="10to20" onChange={() => setSizeOfOrganisation10to20('10-20')} /></td>
                                </tr>
                                <tr>
                                    <td>C. 20 - 50</td>
                                    <td><input type="radio" id="20to50" name="size" value="20to50" onChange={() => setSizeOfOrganisation20to50('20-50')} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 50</td>
                                    <td> <input type="radio" id="above50" name="size" value="above50" onChange={() => setSizeOfOrganisationAbove50('Above 50')} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Ownership */}
                        <h5>2. Ownership (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Sole Proprietor</td>
                                    <td> <input type="checkbox" id="soleProprietor" onChange={() => setOwnershipSoleProprietor(!ownershipSoleProprietor)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Partnership Firm</td>
                                    <td> <input type="checkbox" id="partnershipFirm" onChange={() => setOwnershipPartnershipFirm(!ownershipPartnershipFirm)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Private limited Company</td>
                                    <td> <input type="checkbox" id="privateLimitedCompany" onChange={() => setOwnershipPrivateLimitedCompany(!ownershipPrivateLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Limited Company</td>
                                    <td> <input type="checkbox" id="limitedCompany" onChange={() => setOwnershipLimitedCompany(!ownershipLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Cooperative Society</td>
                                    <td> <input type="checkbox" id="cooperativeSociety" onChange={() => setOwnershipCooperativeSociety(!ownershipCooperativeSociety)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Sector */}
                        <h5>3. Sector (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Private</td>
                                    <td>  <input type="checkbox" id="private" onChange={() => setSectorPrivate(!sectorPrivate)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Public</td>
                                    <td> <input type="checkbox" id="public" onChange={() => setSectorPublic(!sectorPublic)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Government - Central</td>
                                    <td> <input type="checkbox" id="governmentCentral" onChange={() => setSectorGovernmentCentral(!sectorGovernmentCentral)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Government - State</td>
                                    <td> <input type="checkbox" id="governmentState" onChange={() => setSectorGovernmentState(!sectorGovernmentState)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Others</td>
                                    <td>  <input type="checkbox" id="others" onChange={() => setSectorOthers(!sectorOthers)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* No of Employees */}
                        <h5>4. No of Employees (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Less than 20</td>
                                    <td> <input type="checkbox" id="lessThan20" onChange={() => setNoOfEmployeesLessThan20(!noOfEmployeesLessThan20)} /></td>
                                </tr>
                                <tr>
                                    <td>B. 20 - 50</td>
                                    <td> <input type="checkbox" id="20to50Employees" onChange={() => setNoOfEmployees20to50(!noOfEmployees20to50)} /></td>
                                </tr>
                                <tr>
                                    <td>C. 50 - 100</td>
                                    <td> <input type="checkbox" id="50to100Employees" onChange={() => setNoOfEmployees50to100(!noOfEmployees50to100)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 100</td>
                                    <td> <input type="checkbox" id="above100Employees" onChange={() => setNoOfEmployeesAbove100(!noOfEmployeesAbove100)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Financial results for last 3 years */}
                        <h5>5. Financial results for last 3 years (As per Annual reports) (In Rs Cr)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Year</th>
                                    <th>Turnover</th>
                                    <th>Net Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>2021-22</td>
                                    <td>0-10</td>
                                    <td>   <input type="text" className="form-control" value={financialResults2021_22} onChange={(e) => setFinancialResults2021_22(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>2022-23</td>
                                    <td>10-50</td>
                                    <td> <input type="text" className="form-control" value={financialResults2022_23} onChange={(e) => setFinancialResults2022_23(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>2023-24</td>
                                    <td>50-100 & above</td>
                                    <td> <input type="text" className="form-control" value={financialResults2023_24} onChange={(e) => setFinancialResults2023_24(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Main Products/Services */}
                        <h5>6. Main Products/Services (Mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Capacity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description1} onChange={(e) => setMainProductsServicesDescription1(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity1} onChange={(e) => setMainProductsServicesCapacity1(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description2} onChange={(e) => setMainProductsServicesDescription2(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity2} onChange={(e) => setMainProductsServicesCapacity2(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description3} onChange={(e) => setMainProductsServicesDescription3(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity3} onChange={(e) => setMainProductsServicesCapacity3(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>7. Major facilities (mention details) (Fill relevant details based on type of your company)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Facility</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a</td>
                                    <td>Land area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_land_area} onChange={(e) => setMajorFacilitiesLandArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>b</td>
                                    <td>Factory built up area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_factory_built_up_area} onChange={(e) => setMajorFacilitiesFactoryBuiltUpArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>c</td>
                                    <td>Major Equipment</td>
                                    <td><input type="text" className="form-control" value={major_facilities_major_equipment} onChange={(e) => setMajorFacilitiesMajorEquipment(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>d</td>
                                    <td>Specialized Facility</td>
                                    <td><input type="text" className="form-control" value={major_facilities_specialized_facility} onChange={(e) => setMajorFacilitiesSpecializedFacility(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>e</td>
                                    <td>Services</td>
                                    <td><input type="text" className="form-control" value={major_facilities_services} onChange={(e) => setMajorFacilitiesServices(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>8. Technology adopted (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Traditional</td>
                                    <td><input type="checkbox" checked={technology_adopted_traditional} onChange={(e) => setTechnologyAdoptedTraditional(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Indigenous</td>
                                    <td><input type="checkbox" checked={technology_adopted_indigenous} onChange={(e) => setTechnologyAdoptedIndigenous(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. In house R & D</td>
                                    <td><input type="checkbox" checked={technology_adopted_in_house_r_d} onChange={(e) => setTechnologyAdoptedInHouseRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Foreign Technology</td>
                                    <td><input type="checkbox" checked={technology_adopted_foreign_technology} onChange={(e) => setTechnologyAdoptedForeignTechnology(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Franchise</td>
                                    <td><input type="checkbox" checked={technology_adopted_franchise} onChange={(e) => setTechnologyAdoptedFranchise(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={technology_adopted_comment} onChange={(e) => setTechnologyAdoptedComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />


                        {/* Quality Compliance */}
                        <h5>9. Quality Compliance (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. ISO</td>
                                    <td><input type="checkbox" checked={quality_compliance_iso} onChange={(e) => setQualityComplianceIso(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. BIS</td>
                                    <td><input type="checkbox" checked={quality_compliance_bis} onChange={(e) => setQualityComplianceBis(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. GMP/WHO/FDA/HACCP</td>
                                    <td><input type="checkbox" checked={quality_compliance_gmp_who_fda_haccp} onChange={(e) => setQualityComplianceGmpWhoFdaHaccp(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Any other, to mention</td>
                                    <td><input type="checkbox" checked={quality_compliance_other} onChange={(e) => setQualityComplianceOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={quality_compliance_comment} onChange={(e) => setQualityComplianceComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>10. Management Functions – Has (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Human Resources Department</td>
                                    <td><input type="checkbox" checked={management_functions_human_resources_department} onChange={(e) => setManagementFunctionsHumanResourcesDepartment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Finance & Accounts</td>
                                    <td><input type="checkbox" checked={management_functions_finance_accounts} onChange={(e) => setManagementFunctionsFinanceAccounts(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. Marketing/ Business Development</td>
                                    <td><input type="checkbox" checked={management_functions_marketing_business_development} onChange={(e) => setManagementFunctionsMarketingBusinessDevelopment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. R & D</td>
                                    <td><input type="checkbox" checked={management_functions_r_d} onChange={(e) => setManagementFunctionsRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Internal Audit</td>
                                    <td><input type="checkbox" checked={management_functions_internal_audit} onChange={(e) => setManagementFunctionsInternalAudit(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>f. Quality Assurance</td>
                                    <td><input type="checkbox" checked={management_functions_quality_assurance} onChange={(e) => setManagementFunctionsQualityAssurance(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>g. Any other, please specify</td>
                                    <td><input type="checkbox" checked={management_functions_other} onChange={(e) => setManagementFunctionsOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={management_functions_comment} onChange={(e) => setManagementFunctionsComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>12. Level of IT intervention (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Use of ERP</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_use_of_erp} onChange={(e) => setLevelOfITInterventionUseOfERP(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Customized software</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_customized_software} onChange={(e) => setLevelOfITInterventionCustomizedSoftware(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. General office solutions</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_general_office_solutions} onChange={(e) => setLevelOfITInterventionGeneralOfficeSolutions(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. No IT facility</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_no_it_facility} onChange={(e) => setLevelOfITInterventionNoITFacility(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={level_of_it_intervention_comment} onChange={(e) => setLevelOfITInterventionComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        {/* In receipt of any Award */}
                        <h5>13. In receipt of any Award/recognition of repute</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="award" checked={award_recognition_yes} onChange={() => setAwardRecognitionYes(true)} /> YES
                                <input type="radio" name="award" checked={award_recognition_no} onChange={() => setAwardRecognitionNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={award_recognition_comment} onChange={(e) => setAwardRecognitionComment(e.target.value)} placeholder="If yes, to mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Strategic Plan */}
                        <h5>14. Does the Organization have a Strategic Plan for future growth</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_yes} onChange={() => setStrategicPlanForFutureYes(true)} /> YES
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_no} onChange={() => setStrategicPlanForFutureNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={strategic_plan_for_future_comment} onChange={(e) => setStrategicPlanForFutureComment(e.target.value)} placeholder="If yes, mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* About Product/Service */}
                        <h3>A. About Product/ Service:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Description of product / service</td>
                                    <td><input type="text" className="form-control" value={about_product_service_description} onChange={(e) => setAboutProductServiceDescription(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Capacity</td>
                                    <td><input type="text" className="form-control" value={about_product_service_capacity} onChange={(e) => setAboutProductServiceCapacity(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Features of product</td>
                                    <td><input type="text" className="form-control" value={about_product_service_features} onChange={(e) => setAboutProductServiceFeatures(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Uniqueness, if any</td>
                                    <td><input type="text" className="form-control" value={about_product_service_uniqueness} onChange={(e) => setAboutProductServiceUniqueness(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Market</td>
                                    <td><input type="text" className="form-control" value={about_product_service_market} onChange={(e) => setAboutProductServiceMarket(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Export content in Turnover</td>
                                    <td><input type="text" className="form-control" value={about_product_service_export_content_in_turnover} onChange={(e) => setAboutProductServiceExportContentInTurnover(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* About Chief Promoter */}
                        <h3>B. About Chief Promoter:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Educational qualification</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_educational_qualification} onChange={(e) => setAboutChiefPromoterEducationalQualification(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Experience in line</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_experience_in_line} onChange={(e) => setAboutChiefPromoterExperienceInLine(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Are you first generation entrepreneur?</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_first_generation_entrepreneur} onChange={(e) => setAboutChiefPromoterFirstGenerationEntrepreneur(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Contribution to the Organization</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_contribution_to_organisation} onChange={(e) => setAboutChiefPromoterContributionToOrganisation(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Any relevant details, to specify</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_relevant_details} onChange={(e) => setAboutChiefPromoterRelevantDetails(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="mb-3">
                            <label className="form-label">Signature:</label>
                            <input value={signatureUrl} onChange={(e) => setSignatureUrl(e.target.value)} type="file" className="form-control" placeholder="Signature" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Name:</label>
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Name" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Designation:</label>
                            <input value={designation} onChange={(e) => setDesignation(e.target.value)} type="text" className="form-control" placeholder="Designation" style={{ border: '2px solid #000' }} />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit2} className="btn btn-primary w-100">Submit</button>
                        </div>

                        <p><strong>(To be signed by CEO/MD of Organization)</strong></p>

                    </form>
                </div>
            )}

            {formStep === 3 && (
                <div className="container mt-5">
                    <h4 className='text-center'>SAMLL SCALE Entrepreneur of the Year</h4>

                    <form>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">
                                <FaUser /> 1. Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Enter Name"
                                value={Name7}
                                onChange={(e) => setName7(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="designation" className="form-label">
                                Designation
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="designation"
                                placeholder="Enter Designation"
                                value={Designation7}
                                onChange={(e) => setDesignation7(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="age" className="form-label">
                                <FaCalendarAlt /> 2. Age
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                id="age"
                                placeholder="Enter Age"
                                value={Age}
                                onChange={(e) => setAge(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="qualification" className="form-label">
                                <FaGraduationCap /> 3. Qualification (mention details)
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>S No</th>
                                        <th>Discipline</th>
                                        <th>PG</th>
                                        <th>Graduate</th>
                                        <th>Other (to specify)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>A</td>
                                        <td>Technical</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Technical_PG}
                                                onChange={(e) => setTechnicalPG(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Technical_Graduate}
                                                onChange={(e) => setTechnicalGraduate(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Technical_Other}
                                                onChange={(e) => setTechnicalOther(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>B</td>
                                        <td>Financial</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Financial_PG}
                                                onChange={(e) => setFinancialPG(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Financial_Graduate}
                                                onChange={(e) => setFinancialGraduate(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Financial_Other}
                                                onChange={(e) => setFinancialOther(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>C</td>
                                        <td>Management</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Management_PG}
                                                onChange={(e) => setManagementPG(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Management_Graduate}
                                                onChange={(e) => setManagementGraduate(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Management_Other}
                                                onChange={(e) => setManagementOther(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>D</td>
                                        <td>Professional</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Professional_PG}
                                                onChange={(e) => setProfessionalPG(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Professional_Graduate}
                                                onChange={(e) => setProfessionalGraduate(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Professional_Other}
                                                onChange={(e) => setProfessionalOther(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>E</td>
                                        <td>Other (to specify)</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Other_PG}
                                                onChange={(e) => setOtherPG(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Other_Graduate}
                                                onChange={(e) => setOtherGraduate(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={Other_Other}
                                                onChange={(e) => setOtherOther(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="experience" className="form-label">
                                <FaIndustry /> 4. Experience
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Total (in Years)</th>
                                        <th>In same line</th>
                                        <th>In Same Organization</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Experience_Total}
                                                onChange={(e) => setExperienceTotal(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Experience_In_Same_Line}
                                                onChange={(e) => setExperienceInSameLine(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Experience_In_Same_Organization}
                                                onChange={(e) => setExperienceInSameOrganization(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="chiefPromotor" className="form-label">
                                <FaCheck /> 5. Is Nominee Chief Promotor
                            </label>
                            <select id="chiefPromotor" style={{ width: '100%', padding: '8px', fontSize: '14px' }} value={Nominee_Chief_Promotor} onChange={(e) => setNomineeChiefPromotor(e.target.value)}>
                                <option value="">select</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="firstGeneration" className="form-label">
                                <FaCheck /> 6. Is Nominee a First Generation Entrepreneur
                            </label>
                            <select id="firstGeneration" style={{ width: '100%', padding: '8px', fontSize: '14px' }} value={Nominee_First_Generation} onChange={(e) => setNomineeFirstGeneration(e.target.value)}>
                                <option value="">select</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="familyBackground" className="form-label">
                                <FaFileAlt /> 7. Family Background (tick appropriately)
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Business</th>
                                        <th>Industry</th>
                                        <th>Agriculture</th>
                                        <th>Service</th>
                                        <th>Other (to specify)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Business}
                                                onChange={(e) => setBusiness(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Industry}
                                                onChange={(e) => setIndustry(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Agriculture}
                                                onChange={(e) => setAgriculture(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Service}
                                                onChange={(e) => setService(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Other_Tech}
                                                onChange={(e) => setOtherTech(e.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Details in brief"
                                value={Family_Background_comment}
                                onChange={(e) => setFamilyBackgroundComment(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="productService" className="form-label">
                                <FaBox /> 8. About Product / Service (tick appropriately)
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Traditional</th>
                                        <th>Existing</th>
                                        <th>Innovative</th>
                                        <th>Import Substitute</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Traditional}
                                                onChange={(e) => setTraditional(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Existing}
                                                onChange={(e) => setExisting(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Innovative}
                                                onChange={(e) => setInnovative(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Import_Substitute}
                                                onChange={(e) => setImportSubstitute(e.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Details in brief"
                                value={Product_Service_comment}
                                onChange={(e) => setProductServiceComment(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* Source of Technology */}
                        <div className="mb-3">
                            <label htmlFor="sourceTechnology" className="form-label">
                                <FaCogs /> 9. Source of Technology (tick appropriately)
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Indigenous</th>
                                        <th>Own R&D</th>
                                        <th>Imported</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Indigenous}
                                                onChange={(e) => setIndigenous(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Own_RD}
                                                onChange={(e) => setOwnRD(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Imported}
                                                onChange={(e) => setImported(e.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Details in brief"
                                value={Source_of_Technology_Comment}
                                onChange={(e) => setSourceOfTechnologyComment(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* Size of Unit */}
                        <div className="mb-3">
                            <label htmlFor="sizeOfUnit" className="form-label">
                                <FaHandshake /> 10. Size of Unit
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Attribute</th>
                                        <th>At Start (1st Year)</th>
                                        <th>At End of Last FY</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Investment in Rs Cr</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Investment_in_Rs_Cr_At_Start}
                                                onChange={(e) => setInvestmentAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Investment_in_Rs_Cr_At_End}
                                                onChange={(e) => setInvestmentAtEnd(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Term Loan in Rs Cr</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Term_Loan_in_Rs_Cr_At_Start}
                                                onChange={(e) => setTermLoanAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Term_Loan_in_Rs_Cr_At_End}
                                                onChange={(e) => setTermLoanAtEnd(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Turnover in Rs Cr</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Turnover_in_Rs_Cr_At_Start}
                                                onChange={(e) => setTurnoverAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Turnover_in_Rs_Cr_At_End}
                                                onChange={(e) => setTurnoverAtEnd(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>PBT in Rs Cr</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={PBT_in_Rs_Cr_At_Start}
                                                onChange={(e) => setPBTAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={PBT_in_Rs_Cr_At_End}
                                                onChange={(e) => setPBTAtEnd(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Manpower: Skilled + Unskilled</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Manpower_Skilled_Unskilled_At_Start}
                                                onChange={(e) => setManpowerAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Manpower_Skilled_Unskilled_At_End}
                                                onChange={(e) => setManpowerAtEnd(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Exports in Rs Cr</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Exports_in_Rs_Cr_At_Start}
                                                onChange={(e) => setExportsAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Exports_in_Rs_Cr_At_End}
                                                onChange={(e) => setExportsAtEnd(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Financial Indicators */}
                        <div className="mb-3">
                            <label htmlFor="financialIndicators" className="form-label">
                                <FaDollarSign /> 11. Financial Indicators (Last 3 Years)
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Attribute/Year</th>
                                        <th>At Start (1st Year)</th>
                                        <th>Year 1 (2022-23)</th>
                                        <th>Year 2 (2023-24)</th>
                                        <th>Year 3 (2024-25)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Turnover Row */}
                                    <tr>
                                        <td>Turnover</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Turnover_At_Start}
                                                onChange={(e) => setTurnoverAtStartYear(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Turnover_Year1}
                                                onChange={(e) => setTurnoverYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Turnover_Year2}
                                                onChange={(e) => setTurnoverYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Turnover_Year3}
                                                onChange={(e) => setTurnoverYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* PAT Row */}
                                    <tr>
                                        <td>PAT</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={PAT_At_Start}
                                                onChange={(e) => setPATAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={PAT_Year1}
                                                onChange={(e) => setPATYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={PAT_Year2}
                                                onChange={(e) => setPATYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={PAT_Year3}
                                                onChange={(e) => setPATYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* DER Row */}
                                    <tr>
                                        <td>DER</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={DER_At_Start}
                                                onChange={(e) => setDERAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={DER_Year1}
                                                onChange={(e) => setDERYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={DER_Year2}
                                                onChange={(e) => setDERYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={DER_Year3}
                                                onChange={(e) => setDERYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* Net Profit/Sales Row */}
                                    <tr>
                                        <td>Net Profit/Sales</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Profit_Sales_At_Start}
                                                onChange={(e) => setNetProfitSalesAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Profit_Sales_Year1}
                                                onChange={(e) => setNetProfitSalesYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Profit_Sales_Year2}
                                                onChange={(e) => setNetProfitSalesYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Profit_Sales_Year3}
                                                onChange={(e) => setNetProfitSalesYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* Current Ratio Row */}
                                    <tr>
                                        <td>Current Ratio</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Current_Ratio_At_Start}
                                                onChange={(e) => setCurrentRatioAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Current_Ratio_Year1}
                                                onChange={(e) => setCurrentRatioYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Current_Ratio_Year2}
                                                onChange={(e) => setCurrentRatioYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Current_Ratio_Year3}
                                                onChange={(e) => setCurrentRatioYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* Net Worth Row */}
                                    <tr>
                                        <td>Net Worth</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Worth_At_Start}
                                                onChange={(e) => setNetWorthAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Worth_Year1}
                                                onChange={(e) => setNetWorthYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Worth_Year2}
                                                onChange={(e) => setNetWorthYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Net_Worth_Year3}
                                                onChange={(e) => setNetWorthYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* ROI Row */}
                                    <tr>
                                        <td>ROI</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={ROI_At_Start}
                                                onChange={(e) => setROIAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={ROI_Year1}
                                                onChange={(e) => setROIYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={ROI_Year2}
                                                onChange={(e) => setROIYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={ROI_Year3}
                                                onChange={(e) => setROIYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                    {/* Revenue per Employee Row */}
                                    <tr>
                                        <td>Revenue per Employee</td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Revenue_per_Employee_At_Start}
                                                onChange={(e) => setRevenuePerEmployeeAtStart(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Revenue_per_Employee_Year1}
                                                onChange={(e) => setRevenuePerEmployeeYear1(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Revenue_per_Employee_Year2}
                                                onChange={(e) => setRevenuePerEmployeeYear2(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={Revenue_per_Employee_Year3}
                                                onChange={(e) => setRevenuePerEmployeeYear3(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Orientation for Quality */}
                        <div className="mb-3">
                            <label htmlFor="qualityOrientation" className="form-label">
                                12. Orientation for Quality
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>ISO</th>
                                        <th>HACCP</th>
                                        <th>WHO/GMP/FDA</th>
                                        <th>Any Other</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={ISO}
                                                onChange={(e) => setISO(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={HACCP}
                                                onChange={(e) => setHACCP(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={WHO_GMP_FDA}
                                                onChange={(e) => setWHO_GMP_FDA(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Any_Other}
                                                onChange={(e) => setAnyOther(e.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Comments"
                                style={{ border: '2px solid #000' }}
                                value={Orientation_for_Quality_comment}
                                onChange={(e) => setOrientationForQualityComment(e.target.value)}
                            ></textarea>
                        </div>

                        {/* Product Caters to */}
                        <div className="mb-3">
                            <label htmlFor="productCaterTo" className="form-label">
                                13. Product Caters to
                            </label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Large Companies</th>
                                        <th>Small Units</th>
                                        <th>Public At Large</th>
                                        <th>Export</th>
                                        <th>As OEM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Large_Companies}
                                                onChange={(e) => setLargeCompanies(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Small_Units}
                                                onChange={(e) => setSmallUnits(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Public_At_Large}
                                                onChange={(e) => setPublicAtLarge(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={Export_As_OEM}
                                                onChange={(e) => setExportAsOEM(e.target.checked)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={As_OEM}
                                                onChange={(e) => setAsOEM(e.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Details in brief"
                                style={{ border: '2px solid #000' }}
                                value={Product_Caters_comment}
                                onChange={(e) => setProductCatersComment(e.target.value)}
                            ></textarea>
                        </div>

                        {/* Competitors */}
                        <div className="mb-3">
                            <label htmlFor="competitors" className="form-label">Competitors</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                                <thead>
                                    <tr>
                                        <th>Large Companies</th>
                                        <th>Small Units</th>
                                        <th>Multi Nationals</th>
                                        <th>Imports</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="checkbox" checked={Large_Companies_Comment} onChange={(e) => setLargeCompaniesComment(e.target.checked)} /></td>
                                        <td><input type="checkbox" checked={Small_Units_Comment} onChange={(e) => setSmallUnitsComment(e.target.checked)} /></td>
                                        <td><input type="checkbox" checked={Multi_Nationals} onChange={(e) => setMultiNationals(e.target.checked)} /></td>
                                        <td><input type="checkbox" checked={Imports} onChange={(e) => setImports(e.target.checked)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Details in brief"
                                style={{ border: '2px solid #000' }}
                                value={Competitors_comment}
                                onChange={(e) => setCompetitorsComment(e.target.value)}
                            />
                        </div>

                        {/* Contribution of Nominee */}
                        <div className="mb-3">
                            <label htmlFor="nomineeContribution" className="form-label">
                                14. Contribution of nominee for Organization:( a brief on each of following, as applicable)
                            </label>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="increaseTurnover"
                                    name="contribution"
                                    checked={Increase_in_turnover}
                                    onChange={handleRadioChange(setIncreaseInTurnover)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="increaseTurnover">Increase in turnover</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="increaseProductivity"
                                    name="contribution"
                                    checked={Increase_in_productivity}
                                    onChange={handleRadioChange(setIncreaseInProductivity)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="increaseProductivity">Increase in productivity</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="increaseQuality"
                                    name="contribution"
                                    checked={Increase_in_quality}
                                    onChange={handleRadioChange(setIncreaseInQuality)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="increaseQuality">Increase in quality/use of quality tools</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="increaseOperations"
                                    name="contribution"
                                    checked={Increase_in_areas_of_operation}
                                    onChange={handleRadioChange(setIncreaseInAreasOfOperation)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="increaseOperations">Increase in areas of operation</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="newPractices"
                                    name="contribution"
                                    checked={Introduction_of_new_practices}
                                    onChange={handleRadioChange(setIntroductionOfNewPractices)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="newPractices">Introduction of new practices</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="innovations"
                                    name="contribution"
                                    checked={Innovations_done}
                                    onChange={handleRadioChange(setInnovationsDone)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="innovations">Innovations done</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="goodHRPractices"
                                    name="contribution"
                                    checked={Implemented_Good_HR_practices}
                                    onChange={handleRadioChange(setImplementedGoodHRPractices)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="goodHRPractices">Implemented Good HR practices</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="turnAroundActivity"
                                    name="contribution"
                                    checked={Any_turnaround_activity}
                                    onChange={handleRadioChange(setAnyTurnaroundActivity)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="turnAroundActivity">Any turn around activity</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="strategicPlan"
                                    name="contribution"
                                    checked={Devising_strategic_plan}
                                    onChange={handleRadioChange(setDevisingStrategicPlan)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="strategicPlan">Devising strategic plan and implementing</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="innovativeIT"
                                    name="contribution"
                                    checked={Use_of_innovative_IT}
                                    onChange={handleRadioChange(setUseOfInnovativeIT)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="innovativeIT">Use of innovative IT practices/MIS</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="rndDevelopment"
                                    name="contribution"
                                    checked={Development_of_RD_and_technology}
                                    onChange={handleRadioChange(setDevelopmentOfRDandTechnology)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="rndDevelopment">Development of R & D and use of the technology</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="energyConservation"
                                    name="contribution"
                                    checked={Energy_conservation_green_energy}
                                    onChange={handleRadioChange(setEnergyConservationGreenEnergy)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="energyConservation">Energy conservation, Use of Green Energy</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="csrActivities"
                                    name="contribution"
                                    checked={CSR_activities}
                                    onChange={handleRadioChange(setCSRActivities)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="csrActivities">CSR activities</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="recognitionAwards"
                                    name="contribution"
                                    checked={Received_Recognition_awards}
                                    onChange={handleRadioChange(setReceivedRecognitionAwards)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="recognitionAwards">Received any Recognition/ awards of repute</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="promotedUnits"
                                    name="contribution"
                                    checked={Promoted_other_units}
                                    onChange={handleRadioChange(setPromotedOtherUnits)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="promotedUnits">Promoted any other units</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="competingWithLarge"
                                    name="contribution"
                                    checked={Competing_with_large_Enterprises}
                                    onChange={handleRadioChange(setCompetingWithLargeEnterprises)}
                                    style={{ border: '2px solid #000' }}
                                />
                                <label className="form-check-label" htmlFor="competingWithLarge">Competing with large Undertakings/ Multi Nationals</label>
                            </div>

                            <textarea
                                className="form-control"
                                rows="6"
                                placeholder="Describe the nominee's contributions"
                                style={{ border: '2px solid #000' }}
                                value={Nominee_for_Organization_comment}
                                onChange={(e) => setNomineeForOrganizationComment(e.target.value)}

                            ></textarea>
                        </div>


                        {/* Significant Performance */}
                        <div className="mb-3">
                            <label htmlFor="significantPerformance" className="form-label">
                                Any contribution /performance, which can be said as significant (give details):
                            </label>
                            <textarea
                                className="form-control"
                                rows="4"
                                placeholder="Provide details"
                                style={{ border: '2px solid #000' }}
                                value={Contribution_performance_comment}
                                onChange={(e) => setContributionPerformanceComment(e.target.value)}
                            ></textarea>
                        </div>

                        {/* Eligibility for Award */}
                        <div className="mb-3">
                            <label htmlFor="eligibilityForAward" className="form-label">
                                Why you consider the nominee eligible for this award
                            </label>
                            <textarea
                                className="form-control"
                                rows="5"
                                placeholder="Write in 200 words"
                                style={{ border: '2px solid #000' }}
                                value={Eligible_for_this_award_comment}
                                onChange={(e) => setEligibleForThisAwardComment(e.target.value)}
                            ></textarea>
                        </div>

                        {/* Date */}
                        <div className="mb-3">
                            <label htmlFor="" className="form-label">
                                Date
                            </label>
                            <input
                                className="form-control"
                                type="date"
                                value={Date}
                                onChange={(e) => setDate(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* Signature of CEO/MD */}
                        <div className="mb-3">
                            <label htmlFor="" className="form-label">
                                Signature of CEO/MD
                            </label>
                            <input
                                className="form-control"
                                type="file"
                                id="signature"
                                onChange={handleFileChange}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        {/* Name */}
                        <div className="mb-3">
                            <label htmlFor="" className="form-label">
                                Name
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter your name"
                                value={Name1}
                                onChange={(e) => setName1(e.target.value)}
                                style={{ border: '2px solid #000' }}
                            />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit} className="btn btn-primary w-100">Submit</button>
                        </div>

                    </form>
                </div>
            )}

            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>

        </>
    );
};

export default Form3f9;
